import { combineReducers } from "@reduxjs/toolkit";
import * as auth from "../../app/modules/auth";

export const rootReducer = combineReducers({
  auth: auth.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;
